import { render, staticRenderFns } from "./addStory.vue?vue&type=template&id=904e3270&scoped=true"
import script from "./addStory.vue?vue&type=script&lang=js"
export * from "./addStory.vue?vue&type=script&lang=js"
import style0 from "./addStory.vue?vue&type=style&index=0&id=904e3270&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "904e3270",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('904e3270')) {
      api.createRecord('904e3270', component.options)
    } else {
      api.reload('904e3270', component.options)
    }
    module.hot.accept("./addStory.vue?vue&type=template&id=904e3270&scoped=true", function () {
      api.rerender('904e3270', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/exercise/list/addStory.vue"
export default component.exports